import { snackbarActions as actionTypes } from "../config/action-config.js";

export const successSnackbar = (message = "Success") => async (dispatch) => {
    dispatch({ type: actionTypes.SHOW, severity: "success", message })
}

export const errorSnackbar = (message = "Error Occured") => async (dispatch) => {
    dispatch({ type: actionTypes.SHOW, severity: "error", message })
}

export const infoSnackbar = (message = "Info") => async (dispatch) => {
    dispatch({ type: actionTypes.SHOW, severity: "info", message })
}

export const hideSnackbar = () => async (dispatch) => {
    dispatch({ type: actionTypes.HIDE })
}

